import { Link } from 'react-router-dom';

export default function CTAWorksheetSwish() {
  return (
    <section className="py-20 bg-gradient-to-br from-purple-600 via-pink-600 to-rose-600">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border-2 border-white/20">
          <h2 className="text-4xl font-bold text-white mb-6">
            Continue Sua Jornada de Transformação
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Explore outros exercícios poderosos de PNL e Alta Performance para acelerar seus resultados
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Link
              to="/exercicio/ancoragem-emocional-pnl"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-2xl p-6 transition-all duration-300 hover:scale-105 border-2 border-white/30"
            >
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-anchor-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-white mb-2">Ancoragem PNL</h3>
              <p className="text-sm text-white/80">Crie gatilhos emocionais positivos instantâneos</p>
            </Link>

            <Link
              to="/exercicio/encantations-tony-robbins"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-2xl p-6 transition-all duration-300 hover:scale-105 border-2 border-white/30"
            >
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-white mb-2">Encantations</h3>
              <p className="text-sm text-white/80">Reprograme crenças com movimento e emoção</p>
            </Link>

            <Link
              to="/exercicio/identidade-alta-performance"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-2xl p-6 transition-all duration-300 hover:scale-105 border-2 border-white/30"
            >
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-3xl text-white"></i>
              </div>
              <h3 className="font-bold text-white mb-2">Identidade</h3>
              <p className="text-sm text-white/80">Construa sua identidade de alta performance</p>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/planos"
              className="px-8 py-4 bg-white text-purple-600 rounded-full font-bold hover:shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              Ver Todos os Exercícios
            </Link>

            <button
              onClick={() => window.print()}
              className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white rounded-full font-semibold hover:bg-white/30 transition-all duration-300 border-2 border-white/30 whitespace-nowrap"
            >
              <i className="ri-printer-line mr-2"></i>
              Imprimir Worksheet
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}